import React,{useEffect} from 'react';
import './Career.css';

const OpeningPopUp = () => {
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])
  return (
    <div className='container-fluid' id='opening-popup'>
      <div className="row">
        <h1>Currently, there are no openings...</h1>
      </div>
    </div>
  )
}

export default OpeningPopUp
